import React from "react";

const Pylecture1 = () => {
  return (
    <div className="bg-gray-100 flex items-center justify-center min-h-screen">
      <div className="w-full max-w-xl p-4 bg-white rounded-lg shadow-md">
        <div className="aspect-w-16 aspect-h-9 mb-4">
          {/* <iframe
            className="w-full h-full rounded-lg"
            src="https://youtu.be/JDx6KZtASmc?si=7UFD18JfUBnwSU-x"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe> */}

          <iframe
            className="w-full rounded-lg"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/JDx6KZtASmc?si=HlWkyK1CxS76bPbL"
            title="Python"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen;"
            //referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <h2 className="text-2xl font-bold mb-2">
          Lecture -1 Introduction to the Python Programming
        </h2>
        <p className="text-gray-700">
          Welcome to this beginner-friendly yet informative video on programming
          languages! In this video, we’ll dive into the basics of programming
          languages, explaining what they are, how they work, and why they’re
          essential for creating software, websites, and apps.
          <br />
          <br />
          We'll then focus on Python, one of the most popular and versatile
          programming languages. Whether you’re a complete beginner or someone
          with experience in programming, you'll learn why Python is the go-to
          language for many developers.
          <br />
          <br />
          Topics covered:
          <br />
          <br />
          What is a programming language?
          <br />
          <br />
          Overview of Python programming
          <br />
          <br />
          Key features of Python that make it beginner-friendly
          <br />
          <br />
          Real-world applications of Python: Web development, data science,
          automation, and more!
          <br />
          <br />
          Why Python is a great choice for both beginners and experienced
          programmers.
          <br />
          <br />
          Introduction to basic Python syntax.
        </p>
      </div>
    </div>
  );
};

export default Pylecture1;
